/*
 * Free gift reconciler.
 *
 * Liquid decides what the cart should contain and writes it onto
 * [data-nh-gift]; this only carries out the single change needed and reloads.
 *
 * Safety: every action is followed by a reload, so a silent failure could loop.
 * Attempts are counted in sessionStorage and capped. The counter is cleared as
 * soon as the cart is in the right state.
 */
(function () {
  const KEY = 'nhGiftAttempts';
  const MAX_ATTEMPTS = 3;
  let running = false;

  function attempts() {
    try {
      return parseInt(sessionStorage.getItem(KEY), 10) || 0;
    } catch (e) {
      return 0;
    }
  }

  function setAttempts(n) {
    try {
      if (n === 0) sessionStorage.removeItem(KEY);
      else sessionStorage.setItem(KEY, String(n));
    } catch (e) {
      /* private mode - fall through, the cap just stops applying */
    }
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then((r) => (r.ok ? r.json() : Promise.reject(new Error(url + ' ' + r.status))));
  }

  function reconcile() {
    const el = document.querySelector('[data-nh-gift]');
    if (!el || running) return;
    if (el.dataset.enabled !== 'true') return;

    const qualifies = el.dataset.qualifies === 'true';
    const variantId = el.dataset.variantId;
    const giftKey = el.dataset.giftKey;
    const giftQty = parseInt(el.dataset.giftQty, 10) || 0;

    // Work out what to do BEFORE doing it, so the attempt cap can veto the
    // request. Firing first and checking after would keep adding a line on
    // every page load once the cap was reached.
    let plan = null;

    if (qualifies && !giftKey && variantId) {
      plan = {
        url: window.routes.cart_add_url + '.js',
        body: { items: [{ id: Number(variantId), quantity: 1, properties: { _free_gift_line: 'Yes' } }] },
      };
    } else if (qualifies && giftQty > 1) {
      // They bumped the quantity; a gift is one per order.
      plan = { url: window.routes.cart_change_url + '.js', body: { id: giftKey, quantity: 1 } };
    } else if (!qualifies && giftKey) {
      plan = { url: window.routes.cart_change_url + '.js', body: { id: giftKey, quantity: 0 } };
    }

    if (!plan) {
      setAttempts(0);
      return;
    }

    if (attempts() >= MAX_ATTEMPTS) {
      console.warn('[nh-free-gift] giving up after %s attempts', MAX_ATTEMPTS);
      return;
    }

    running = true;
    setAttempts(attempts() + 1);

    post(plan.url, plan.body)
      .then(() => window.location.reload())
      .catch((err) => {
        running = false;
        console.warn('[nh-free-gift]', err);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reconcile);
  } else {
    reconcile();
  }

  // Quantity changes on the cart page re-render .js-contents via AJAX, which
  // replaces the data island with fresh Liquid output.
  const contents = document.querySelector('.js-contents');
  if (contents) {
    new MutationObserver(() => reconcile()).observe(contents, { childList: true, subtree: true });
  }
})();
